import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import Swal from "sweetalert2";
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SupportService implements Resolve<any> {
  rows: any;
  data: any;

  onSupportsChanged: BehaviorSubject<any>;
  onFAQChanged: BehaviorSubject<any>;


  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _httpClient: HttpClient) {
    // Set the defaults
    this.onFAQChanged = new BehaviorSubject({});
    this.onSupportsChanged = new BehaviorSubject({});

  }

  /**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getDataTableRows()]).then(() => {
        resolve();
      }, reject);
      
      Promise.all([this.getDataTableRowsSupport()]).then(() => {
        resolve();
      }, reject);
    });
    
  }

  /**
   * Get rows
   */
  getDataTableRows(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._httpClient.get('api/faq-data').subscribe((response: any) => {
        this.data = response;
        this.onFAQChanged.next(this.data);
        resolve(this.data );
      }, reject);
    });
  }
    /**
   * Get rows
   */
    getDataTableRowsSupport(): Promise<any[]> {    
      return new Promise((resolve, reject) => {
        this._httpClient.get(`${environment.apiUrl}/supports`).subscribe((response: any) => {
          this.rows = response;           
          this.onSupportsChanged.next(this.rows);
          resolve(this.rows);
        }, reject);
      });
    }

    /**
   * Add row
   */
    addSupport(data, file): Promise<any[]> {                
      return new Promise((resolve, reject) => {
        this._httpClient.post(`${environment.apiUrl}/supports`, 
        {
          "image":file,
          "title":data.title,
          "category":data.category,
          "priority":data.priority,
          "description":data.description
        }).subscribe((response: any) => {
          this.rows = response;           
          this.onSupportsChanged.next(this.rows);
          Swal.fire({
            title: "Success!",
            text: "This support request have been sent.",
            icon: "success",
            showConfirmButton: false,
            allowOutsideClick: function () {
              return !Swal.isLoading();
            },
          });
          setTimeout(() => {          
            Swal.close()
          }, 2000);
          resolve(this.rows);
        }, reject);
      })
    };
  
}
